import PropTypes from 'prop-types';

import { Abstrap } from '../..';

const propTypes = { ...Abstrap.propTypes, disabled: PropTypes.bool };

const defaultProps = {
    ...Abstrap.defaultProps,
    componentClass: 'a',
    disabled: false,
};

class TooltipItem extends Abstrap {

    getClassNameSchema() {
        const {
            className,
            disabled,
        } = this.props;
        return [
            'c-tooltip__item',
            disabled ? 'c-tooltip__item_disabled' : false,
            className,
        ];
    }

}

TooltipItem.propTypes = propTypes;

TooltipItem.defaultProps = defaultProps;

export default TooltipItem;
